<div id="column-filter" clrForm [attr.data-type]="dataType()" [attr.data-test-id]="'textfilter-' + id()">
  <h4 class="nm">{{ title() ?? column().id | titlecase | mrTranslate }}</h4>
  <div class="clr-row nm clr-flex-nowrap clr-align-items-end">
    <clr-checkbox-container class="clr-col-2">
      <clr-checkbox-wrapper>
        <input type="checkbox" clrCheckbox [(ngModel)]="selectedAll" />
      </clr-checkbox-wrapper>
    </clr-checkbox-container>

    @if (isOperatorVisible()) {
      <clr-select-container class="clr-col-4 nm np">
        <select
          clrSelect
          [(ngModel)]="operator"
          [ngModelOptions]="{ standalone: true }"
          [attr.data-type]="dataType()"
          [attr.data-test-id]="'textfilter-operator-list'">
          @for (op of operators(); track op.value) {
            <option [ngValue]="op" [attr.data-test-id]="'textfilter-operator-list-' + op.value">{{ op.name }}</option>
          }
        </select>
      </clr-select-container>
    }
    @if (isInputVisible()) {
      <div class="clr-col nm clr-flex-column">
        <clr-input-container>
          <input
            clrInput
            [type]="inputType()"
            [(ngModel)]="input1"
            [ngModelOptions]="{ standalone: true }"
            [autofocus]="modalOpened()"
            placeholder="{{ 'Suche' | mrTranslate }}"
            [attr.data-test-id]="'textfilter-input'" />
        </clr-input-container>
        @if (enableSecondSearchInput()) {
          <clr-input-container>
            <input
              clrInput
              [type]="inputType()"
              [(ngModel)]="input2"
              [ngModelOptions]="{ standalone: true }"
              placeholder="{{ 'Suche' | mrTranslate }}"
              [attr.data-test-id]="'textfilter-input2'" />
          </clr-input-container>
        }
      </div>
    }
  </div>

  <div class="clr-break-row"></div>

  <clr-datagrid
    #grid
    class="datagrid-compact w-100-p"
    style="height: 40vh"
    [clrDgSelectionType]="'multi'"
    [clrDgSelected]="selectedItems()"
    (clrDgSelectedChange)="selectedItems.set($event)"
    [clrDgRowSelection]="true"
    [clrDgItemsIdentityFn]="row => row?.name"
    [attr.data-test-id]="'textfilter-grid'">
    <clr-dg-column
      [clrDgField]="'name'"
      [clrDgColType]="inputType() == 'number' ? 'number' : 'string'"
      [clrDgSortOrder]="1">
      {{ 'Werteliste' | mrTranslate }}
    </clr-dg-column>
    <ng-template
      clrVirtualScroll
      let-item
      [clrVirtualRowsOf]="filteredItems()"
      [clrVirtualRowsTrackBy]="(_, row) => row?.name"
      [clrVirtualRowsMinBufferPx]="400">
      <clr-dg-row [clrDgItem]="item">
        @if (isIconColumn()) {
          <clr-dg-cell [title]="item.name" [attr.data-test-id]="'textfilter-grid-cell-' + item.name">
            <cds-icon
              class="grid-icon margin-6-r"
              [title]="item.name"
              [solid]="item.name | get: iconIsSolid"
              [shape]="item.name | get: iconShape"
              [style.color]="item.name | get: iconColor : fkColors()"
              [style.width.px]="iconSize()"
              [style.height.px]="iconSize()" />
            @if (id() == 'typ' && item.name != '-') {
              <span>{{ item.name }}</span>
            }
            @if (id() == 'rep' && item.name != '-') {
              <span>{{ item.name }}</span>
            }
          </clr-dg-cell>
        }
        @else if (id() == 'erlstatus') {
          @switch (item.name) {
            @case (0) {
              <clr-dg-cell class="name-cell" [title]="'Nicht abgeschlossen' | mrTranslate">
                <span class="erlstatus-symbol">&#x2610;</span>
              </clr-dg-cell>
            }
            @case (1) {
              <clr-dg-cell class="name-cell" [title]="'Abgeschlossen' | mrTranslate">
                <span class="erlstatus-symbol">&#x2611;</span>
              </clr-dg-cell>
            }
            @case (2) {
              <clr-dg-cell class="name-cell" [title]="'Teilweise abgeschlossen' | mrTranslate">
                <span class="erlstatus-symbol intermediate">&#x229F;</span>
              </clr-dg-cell>
            }
          }
        } @else {
          <clr-dg-cell [title]="item.name" [attr.data-test-id]="'textfilter-grid-cell-' + item.name">
            <app-dg-cell [data]="item.name" [col]="column().id" />
          </clr-dg-cell>
        }
      </clr-dg-row>
    </ng-template>

    <clr-dg-footer>{{ filteredItems().length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
  </clr-datagrid>

  <div class="clr-row nm clr-justify-content-between">
    <button name="cancel" class="btn btn-sm" (click)="closeCancel()" [attr.data-test-id]="'textfilter-btn-cancel'">
      {{ 'Abbrechen' | mrTranslate }}
    </button>
    <button
      name="reset"
      class="btn btn-sm btn-icon btn-danger"
      (click)="resetWithEmit()"
      [disabled]="!isActive()"
      [attr.data-test-id]="'textfilter-btn-forcereset'"
      title="{{ 'Filter löschen' | mrTranslate }}">
      <cds-icon shape="filter-off" solid="true" />
    </button>
    <button
      type="submit"
      name="submit"
      class="btn btn-primary btn-sm"
      (click)="closeSubmit()"
      [disabled]="!selectedItems().length || (isResetted() && isAllSelected())"
      [attr.data-test-id]="'textfilter-btn-submit'">
      {{ 'Filter anwenden' | mrTranslate }}
    </button>
  </div>
</div>
